import { useMutation } from "@apollo/react-hooks";
import { Modal, Stack } from "@shopify/polaris";
import React, { useCallback, useEffect, useReducer } from "react";
import {
    START_AMAZON_IDEA,
    UPDATE_AMAZON_IDEAS_STORE,
} from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";
import StoreSelect from "../../store/components/StoreSelect";
import { getStoreIds } from "../helper";

export default function AmazonIdeaUpdateStore({
    open,
    onClose,
    ids,
    onCompleted,
    node,
}) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [state, setState] = useReducer(reducerFn, {
        storeIDs: [],
    });

    const [setDelay] = useTimeout();
    const [updateAmazonIdeaStore, { loading }] = useMutation(
        UPDATE_AMAZON_IDEAS_STORE,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Start amazon idea successfully",
                    err: false,
                });

                onClose();
                onCompleted && onCompleted();
                setDelay(() => {
                    refetch && refetch();
                }, 1500);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        if (arrInvalid(state.storeIDs)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        const input = [];
        for (let id of ids) {
            input.push({ id, storeIDs: state.storeIDs });
        }

        updateAmazonIdeaStore({
            variables: { input },
        });
    }, [ids, state.storeIDs]);

    const handleStoreChange = useCallback((value) => {
        setState({ storeIDs: value });
    }, []);

    useEffect(() => {
        const storeIds = getStoreIds(node?.stores);
        if (storeIds.length > 0) {
            setState({ storeIDs: storeIds });
        }
    }, [JSON.stringify(node?.stores)]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sectioned
            title="Amazon Idea Update Store"
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
                disabled: arrInvalid(state.storeIDs),
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <Stack vertical>
                <StoreSelect
                    value={state.storeIDs}
                    filter={{ platform: "amazon", limit: 200 }}
                    onChange={handleStoreChange}
                    getValueImmediate
                    allowMultiple
                />
            </Stack>
        </Modal>
    );
}
